import { Schema } from '@blade/std-lib'

export class TiktokResizePostMessage extends Schema.Class<TiktokResizePostMessage>(
  'TiktokResizePostMessage',
)({
  height: Schema.Number,
  signalSource: Schema.String,
}) {
  static decode = Schema.decodeUnknownOption(
    Schema.fromJsonString(TiktokResizePostMessage),
  )
}
